/**
 * Processor to launch a deeplink.
 *
 * @param {string} deeplink - The deeplink to launch.
 */
export default function launchDeeplink(deeplink) {
  // Try to open the deeplink using a hidden iframe
  const iframe = document.createElement("iframe");

  iframe.style.display = "none";
  iframe.src = deeplink;

  document.body.appendChild(iframe);

  // Clean up iframe after a short delay
  setTimeout(() => {
    document.body.removeChild(iframe);
  }, 2000);
}
